import { render, staticRenderFns } from "./HsabClaimAccountVerify.vue?vue&type=template&id=0bbe2c4a&scoped=true"
import script from "./HsabClaimAccountVerify.vue?vue&type=script&lang=ts"
export * from "./HsabClaimAccountVerify.vue?vue&type=script&lang=ts"
import style0 from "./HsabClaimAccountVerify.vue?vue&type=style&index=0&id=0bbe2c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe2c4a",
  null
  
)

export default component.exports